<template>
  <BaseTableView :head="tableHead" card-view="lgAndDown">
    <WorkClientContactTableItem v-for="item in items" :key="item.id" :item="item" :type="type" />
  </BaseTableView>
</template>

<script>
import WorkClientContactTableItem from 'components/workClient/contact/WorkClientContactTableItem'
export default {
  name: 'WorkClientContactTable',
  props: ['items', 'type'],
  components: { WorkClientContactTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text:
            this.type === 'email'
              ? this.localStorage.translations.pages['setting-client']['contacts'][
                  'elektronnaya-pochta'
                ]
              : this.localStorage.translations.pages['setting-client']['contacts']['telefon'],
        },
        {
          text: this.localStorage.translations.pages['setting-client']['contacts'][
            'kratkoe-opisanie'
          ],
        },
        {active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
